module.exports = __webpack_public_path__ + "img/1.8e5fae4d.jpg";